/**
 * Triggers a browser file download for a CSV-formatted string.
 *
 * @param rows  Two-dimensional array of cell values. The first row is the header.
 * @param filename  The suggested download filename (e.g. "report-2026-01-01.csv").
 */
export function downloadCsv(rows: (string | number)[][], filename: string): void {
  downloadCsvText(
    rows
      .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
      .join('\n'),
    filename
  );
}

/**
 * Like downloadCsv, for text the caller has already quoted.
 *
 * @param csv  The complete file contents.
 * @param filename  The suggested download filename.
 */
export function downloadCsvText(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
